module.exports = __webpack_public_path__ + "img/cover.14bdec9c.png";